// src/modules/notifications/routes.jsx
//
// No PermissionRoute here on purpose: an inbox is not a module. Every
// authenticated user has notifications and settings for them, and both are
// scoped to their own JWT server-side.

import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import NotificationsPage from './pages/NotificationsPage';
import NotificationSettings from './pages/NotificationSettings';

const NotificationRoutes = () => (
  <Routes>
    <Route path="/" element={<NotificationsPage />} />
    <Route path="settings" element={<NotificationSettings />} />
    <Route path="*" element={<Navigate to="/notifications" replace />} />
  </Routes>
);

export default NotificationRoutes;
